import React, { useState } from 'react';
import './App.css';
import Layout from './components/Layout/Layout';
import CalendarComponent from './components/Calendar/CalendarComponent';
import tandslogo from './imageassets/tandslogo.png';

function App() {
  const[isLoggedIn, setIsLoggedIn] = useState(false);
  const onSubmit = ()=>{
    setIsLoggedIn(true)
  }
  return (
    <>
    {isLoggedIn ? (
      <Layout>
        <div className="main_container">
          <div className="topcontent_container">
            <div className="top_content" onClick={()=>alert('This opens up Patients module')}>
              <div style={{
                backgroundImage: "url(/images/patient.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>1</h4>
                    <p>Patient</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Doctors module')}>
              <div style={{
                backgroundImage: "url(/images/doctor.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>2</h4>
                    <p>Doctor</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Nurses module')}>
              <div style={{
                backgroundImage: "url(/images/nurse.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>3</h4>
                    <p>Nurse</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Pharmacist module')}>
              <div style={{
                backgroundImage: "url(/images/pharmacy.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>4</h4>
                    <p>Pharmacy</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Laboratorist module')}>
              <div style={{
                backgroundImage: "url(/images/laboratory.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>5</h4>
                    <p>Laboratorist</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Accounts module')}>
              <div style={{
                backgroundImage: "url(/images/account.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>6</h4>
                    <p>Accountant</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Bedding module')}>
              <div style={{
                backgroundImage: "url(/images/bed.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>7</h4>
                    <p>Bed</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Blood bank module')}>
              <div style={{
                backgroundImage: "url(/images/bloodbank.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>8</h4>
                    <p>Blood Bank</p>
                  </div>
              </div>
            </div>
            <div className="top_content" onClick={()=>alert('This opens up Payment module')}>
              <div style={{
                backgroundImage: "url(/images/payment.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>9</h4>
                    <p>Payment</p>
                  </div>
              </div>
            </div>
            
            <div className="top_content" onClick={()=>alert('This opens up Admin Profile module')}>
              <div style={{
                backgroundImage: "url(/images/profile.png)",
                backgroundRepeat: 'no-repeat',
                width:'180px',
                height:'10rem',
                display:'flex',
                alignItems:'center',
                }}>
                  <div className="content_div">
                    <h4>10</h4>
                    <p>Profile</p>
                  </div>
              </div>
            </div>
          </div>
          <div className="lower_content">
            <CalendarComponent />
          </div>
        </div>
      </Layout>
    ): (
      <div className="loginContainer">
        <div className="header">
          <img className="header_image" src={tandslogo} alt="Logo" />
          <div className="header_div">
              <h5>T &amp; S Hospital</h5>
              <p>Serving you since 1980....</p>
          </div>
        </div>
        <div className="login_form">
          <h3>Login!!!</h3>
          <form onSubmit={onSubmit}>
            <div>
              <input required className="login_input" type="email" placeholder='Enter Email*'/>
            </div>
            <div>
              <input required className="login_input"  type="text" placeholder='Enter Password*' />
            </div>
            <button className="login_button" type='submit'>Login</button>
          </form>
          <div className="join_us">
            <p>Don't have an account? </p>
            <button onClick={()=>alert('It takes you to Register module')} className="join_usbutton"> Join Us</button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}

export default App;















//  <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
